<div class="tcf">
  <header class="tcf-header" *ngIf="!inline">
    <h2>{{ credentialOnly ? 'Add API key' : (editing ? 'Edit service key' : 'Add service key') }}</h2>
  </header>

  <div class="tcf-body" [formGroup]="form">
    <label class="field">
      <span class="field-label">Provider <em>*</em></span>
      <select formControlName="provider">
        <option *ngFor="let p of availableProviders" [value]="p.id">{{ p.label }}</option>
      </select>
      <span class="field-hint" *ngIf="editing">To switch provider, remove this key and add a new one.</span>
    </label>

    <label class="field">
      <span class="field-label">API key <em *ngIf="!editing">*</em></span>
      <input type="password" formControlName="secret" autocomplete="off"
             [placeholder]="editing ? '•••• leave blank to keep current' : (currentMeta?.secretPlaceholder || '')" />
      <span class="field-error" *ngIf="form.get('secret')?.touched && form.get('secret')?.hasError('required')">Required</span>
    </label>

    <label class="field" *ngIf="currentMeta?.needsModel && !credentialOnly">
      <span class="field-label">Model <em>*</em></span>
      <input type="text" formControlName="model" [placeholder]="currentMeta?.modelPlaceholder || ''" />
      <span class="field-hint">The model this service uses.</span>
      <span class="field-error" *ngIf="form.get('model')?.touched && form.get('model')?.hasError('required')">Required</span>
    </label>

    <label class="field">
      <span class="field-label">{{ credentialOnly ? 'Name' : 'Note' }} <em *ngIf="credentialOnly">*</em></span>
      <input type="text" formControlName="note" [placeholder]="credentialOnly ? 'For example: OpenAI company key' : ''" />
      <span *ngIf="credentialOnly && form.get('note')?.touched && form.get('note')?.invalid" class="field-error">Enter a name.</span>
      <span *ngIf="credentialOnly" class="field-hint">Use this name to select the key in other services.</span>
    </label>

    <p *ngIf="previewProviders" class="field-hint">UI preview. This key is not saved.</p>
    <p class="tcf-error" *ngIf="error">{{ error }}</p>
  </div>

  <footer class="tcf-actions">
    <button type="button" class="br-btn br-btn--ghost" *ngIf="!inline" (click)="cancel()">Cancel</button>
    <button type="button" class="br-btn br-btn--primary" [disabled]="form.invalid || saving || !currentMeta" (click)="save()">
      {{ editing ? 'Save' : 'Add key' }}
    </button>
  </footer>
</div>
